module.exports = __webpack_public_path__ + "static/media/uci.b41053c0.jpg";